import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { TypedMemo } from '../../../common/types';
import { KIND_COPY } from './kindCopy';
import { whoMessages as messages } from './whoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for step 2; each part uses its own slice of it */
import styles from './Who.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface KindRowProps {
  kind: OutreachPitchKind;
  on: boolean;
  /** The people of this kind that fit now; null while the count loads. */
  count: number | null;
  /** The last kind that is on cannot go off. */
  disabled: boolean;
  onToggle: (kind: OutreachPitchKind, on: boolean) => void;
}

/** One kind of people of "Who Plug looks for" (design outreach-v2 c1 `ty`): the switch and the count. */
const KindRowComponent: React.FC<KindRowProps> = ({ kind, on, count, disabled, onToggle }) => {
  const intl = useIntl();
  const copy = KIND_COPY[kind];
  const title = intl.formatMessage(copy.title);
  return (
    <div className={clsx(styles.kind, !on && styles.kindOff)} data-testid={`kind-${kind}`}>
      <span className={styles.kindIcon}>
        <FontAwesomeIcon icon={copy.icon} />
      </span>
      <div>
        <b>{title}</b>
        <small>{intl.formatMessage(copy.sub)}</small>
      </div>
      <span className={styles.kindCount}>
        {count === null ? '' : intl.formatMessage(messages.fitNow, { count: intl.formatNumber(count) })}
      </span>
      <input
        type="checkbox"
        role="switch"
        className={styles.switch}
        checked={on}
        disabled={disabled}
        aria-label={title}
        onChange={(event) => onToggle(kind, event.target.checked)}
      />
    </div>
  );
};

export const KindRow = TypedMemo(KindRowComponent);
